import { DataTable } from "lib/@components/data-table/data-table"
import { CheckExistingRow } from "./check-existing-row"

export function CheckExistingTable({ results }) {
    const columns = buildColumns()

    return (
        <DataTable
            columns={columns}
            RowComponent={<CheckExistingRow />}
            items={results}
            keyFn="key"
            sortKey="check-existing-sort"
            pageSizeKey="check-existing-page-size"
            defaultSort={{ field: "similarity", descending: true }}
            itemLabel="tickets"
        />
    )

    function buildColumns() {
        return [
            { field: "key", label: "Ticket", sortable: true, width: 120 },
            { field: "summary", label: "Summary", sortable: true },
            { field: "similarity", label: "Similarity", sortable: true, align: "right", width: 120 },
            { field: "bestLine.sentence", label: "Match reason" },
        ]
    }
}
